import React from 'react'

function qtyError(raw, step) {
  if (raw === '' || raw === undefined) return null
  const value = parseFloat(raw)
  if (Number.isNaN(value)) return 'Wpisz poprawną liczbę.'
  if (value < 0) return 'Ilość nie może być ujemna.'
  if (Math.abs(Math.round(value / step) * step - value) > 1e-6) {
    return step === 1
      ? 'Ilość musi być liczbą całkowitą.'
      : `Ilość musi być wielokrotnością ${step}.`
  }
  return null
}

class TallyForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      qtyProduced: '',
      qtyWaste: '0',
      lotName: ''
    }
  }

  step = (field, delta) => {
    const current = parseFloat(this.state[field]) || 0
    const next = Math.max(0, current + delta)
    this.setState({ [field]: String(next) })
  }

  handleChange = (field) => (e) => {
    this.setState({ [field]: e.target.value })
  }

  render() {
    const { operation, onCancel, onSubmit, submitLabel } = this.props
    const { qtyProduced, qtyWaste, lotName } = this.state

    const limit = operation.qty_limit
    // qty_produced/qty_waste already include whatever earlier sessions reported
    // (e.g. a previous handover) - only what's left of the limit may be added now.
    const alreadyDone = (operation.qty_produced || 0) + (operation.qty_waste || 0)
    const remaining = Math.max(0, limit - alreadyDone)
    const nothingLeft = remaining === 0

    const produced = qtyProduced === '' && nothingLeft ? 0 : parseFloat(qtyProduced)
    const waste = parseFloat(qtyWaste) || 0

    const qtyStep = operation.qty_step || 1
    const inputError = [qtyProduced, qtyWaste].map(raw => qtyError(raw, qtyStep)).find(Boolean)

    const isLimited = remaining < operation.qty_production
    const total = (produced || 0) + waste
    const exceedsLimit = total > remaining
    const closesOperation = total >= remaining
    const showLot = !submitLabel && operation.lot_required && closesOperation && produced > 0
    const canSubmit = !inputError
      && (qtyProduced !== '' || nothingLeft) && !Number.isNaN(produced) && !exceedsLimit
      && (total > 0 || nothingLeft || Boolean(submitLabel))

    const submit = () => onSubmit(produced, waste, showLot ? lotName.trim() : undefined)

    return (
      <div className="tally-stage">
        <div className="tally-card">
          <h3>{operation.production_name}</h3>
          <p className="tally-operation">{operation.name}</p>
          <p className="tally-planned">
            Pierwotnie zaplanowano: <b>{operation.qty_production} szt.</b>
          </p>
          {alreadyDone > 0 && (
            <p className="tally-planned">
              Wykonano do tej pory (poprzednie sesje): <b>{alreadyDone} szt.</b>
            </p>
          )}
          {isLimited && (
            <p className="tally-planned">
              Dostępne do wykonania teraz: <b>{remaining} szt.</b>
            </p>
          )}

          <div className="stepper stepper--done">
            <label>WYKONANO (SZT.)</label>
            <div className="stepper__control">
              <button type="button" onClick={() => this.step('qtyProduced', -1)}>–</button>
              <input type="number" value={qtyProduced}
                onChange={this.handleChange('qtyProduced')} min="0" step={qtyStep} />
              <button type="button" disabled={total >= remaining}
                onClick={() => this.step('qtyProduced', 1)}>+</button>
            </div>
          </div>

          <div className="stepper stepper--waste">
            <label>ODPADY (SZT.)</label>
            <div className="stepper__control">
              <button type="button" onClick={() => this.step('qtyWaste', -1)}>–</button>
              <input type="number" value={qtyWaste}
                onChange={this.handleChange('qtyWaste')} min="0" step={qtyStep} />
              <button type="button" disabled={total >= remaining}
                onClick={() => this.step('qtyWaste', 1)}>+</button>
            </div>
          </div>

          {showLot && (
            <div className="tally-lot">
              <label>NUMER PARTII</label>
              <input type="text" value={lotName} onChange={this.handleChange('lotName')} />
              <p className="tally-planned">
                Bez numeru partii zlecenie nie zamknie się samo — trzeba będzie je zamknąć w ERP.
              </p>
            </div>
          )}

          {inputError && (
            <p className="form-error">{inputError}</p>
          )}

          {exceedsLimit && (
            <p className="form-error">
              Suma wykonanych i odpadów nie może przekroczyć dostępnej ilości ({remaining} szt.).
            </p>
          )}

          <div className="op-actions">
            <button type="button" className="secondary" onClick={onCancel}>Wróć</button>
            <button type="button" disabled={!canSubmit} onClick={submit}>
              {submitLabel || (closesOperation
                ? 'Zatwierdź i zamknij operację'
                : 'Zatwierdź (operacja pozostanie otwarta)')}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default TallyForm
